export const getLocationFormFields = (t) => [
  {
    name: 'locationName',
    label: t('hrms_setting_location_form_name'),
    // labelFooter: t('hrms_setting_location_form_name_footer'),
    placeholder: t('hrms_setting_location_form_name_placeholder'),
    type: 'text',
    required: true,
    fullWidth: true,
    maxLength: 100,
  },
  {
    name: 'locationNameEn',
    label: t('hrms_setting_location_form_title_en'),
    placeholder: t('hrms_setting_location_form_title_en_placeholder'),
    type: 'text',
    required: true,
    fullWidth: true
  },
  {
    name: 'locationNameTh',
    label: t('hrms_setting_location_form_title_th'),
    placeholder: t('hrms_setting_location_form_title_th_placeholder'),
    type: 'text',
    required: true,
    fullWidth: true
  }
]

export const getCoordinateFields = (t) => [
  {
    name: 'lat',
    label: t('hrms_setting_location_form_lat'),
    placeholder: t('hrms_setting_location_form_lat_placeholder'),
    type: 'inputdeci',
    required: true,
    filterType: 'number_with_dot'
  },
  {
    name: 'long',
    label: t('hrms_setting_location_form_long'),
    placeholder: t('hrms_setting_location_form_long_placeholder'),
    type: 'inputdeci',
    required: true,
    filterType: 'number_with_dot'
  }
]

export const getSettingFields = (t) => [
  {
    name: 'status',
    label: t('hrms_setting_location_form_status'),
    labelswitch: t('hrms_setting_location_form_active_status'),
    type: 'switch',
    switchConfig: {
      width: '50%',
      showLabel: true
    }
  },
  {
    name: 'showInAttendance',
    label: t('hrms_setting_location_form_show_atten'),
    labelswitch: t('hrms_setting_location_form_show_atten'),
    type: 'switch',
    switchConfig: {
      width: '50%',
      showLabel: true
    }
  }
]

export const getSettingVFields = (t) => [
  {
    name: 'status',
    label: t('hrms_setting_location_form_status'),
    labelswitch: t('hrms_setting_location_form_status_active'),
    type: 'vswitch',
    switchConfig: {
      width: '50%',
      showLabel: true
    }
  },
  {
    name: 'showInAttendance',
    label: t('hrms_setting_location_form_show_attendance'),
    labelswitch: t('hrms_setting_location_form_show_in_attendance_show'),
    type: 'vswitch',
    switchConfig: {
      width: '50%',
      showLabel: true
    }
  }
]

export const getRadiusFields = (t) => [
  {
    name: 'radius',
    label: t('hrms_setting_location_form_radius'),
    placeholder: t('hrms_setting_location_form_radius_placeholder'),
    type: 'inputnum', // 👈 สำคัญ
    required: true
  }
]

export const getRemarkFields = (t) => [
  {
    name: 'remark',
    label: t('hrms_setting_location_form_remark'),
    placeholder: t('hrms_setting_location_form_remark_placeholder'),
    type: 'text',
    required: false
  }
]
